module.exports = require('./CollectorRepossessorRenewalApplicationView');
